module.exports = require('./CollectorRepossessorRenewalApplicationView');
